import { useEffect } from "react";
import { instagramIsNext, openReviewSheet, type GateProfile } from "../lib/connectBank";
import { endHint, hintDue } from "../lib/welcomeHints";
import { faceIdQuestionSettled, PUSH_ASK_MAX_WAIT_MS } from "../lib/firstSignInMoment";

// The bank is done and Instagram is the one thing left: "Verify your Instagram"
// opens by itself, once per account per device (founder, 2026-11-03; MassPay
// talent already got this from ConnectBankSheet). It reads the state, not the
// way back from Stripe, so every way a bank gets connected is covered. `profile`
// is this visit's copy, never the remembered one.
//
// The practice comes first (founder, 2026-10-11), and it never stacks on the
// Face ID question: the same wait, and the same safety net, as the notification
// ask (lib/firstSignInMoment). VerifyInstagramBanner stays until it's done.
export function useVerifyInstagramNudge(user: { _id?: string; slug?: string } | null | undefined, profile: GateProfile, practiceOn: boolean): void {
  const userId = user?._id;
  const slug = user?.slug;
  const due = !practiceOn && instagramIsNext(profile) && hintDue("verify", slug);

  useEffect(() => {
    if (!due || !slug) return;
    let stopped = false;
    let timer: number | undefined;
    const tryOpen = async (waited: number) => {
      const settled = !userId || (await faceIdQuestionSettled(userId).catch(() => true));
      if (stopped) return;
      if (settled || waited >= PUSH_ASK_MAX_WAIT_MS) {
        endHint("verify", slug);
        openReviewSheet();
        return;
      }
      timer = window.setTimeout(() => void tryOpen(waited + 1000), 1000);
    };
    void tryOpen(0);
    return () => {
      stopped = true;
      window.clearTimeout(timer);
    };
  }, [due, slug, userId]);
}
